import { LinkedChainNavigation } from 'components/linkedChainNavigation/linkedChainNavigation'
import { push } from 'connected-react-router'
import { put, select, takeEvery } from 'redux-saga/effects'
import { RootState } from 'stores'
import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

type Actions = ActionType<typeof actions>

function* navigate(action: Actions) {
  const currentPath = yield select(
    (state: RootState) => state.router.location.pathname
  )
  const chainLink = new LinkedChainNavigation(currentPath)
  const nextPath = action.payload > 0 ? chainLink.next : chainLink.previous
  if (nextPath) {
    yield put(push(nextPath))
  }
}

export function* watchForHorizontalNavigation() {
  yield takeEvery(actions.navigate.toString(), navigate)
}
